<template>

  <b-form class="mt-3" >
    <b-row v-if="props.mode == 'List'">

      
      <b-col
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[1]" />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[2]" />
      </b-col>

    </b-row>


    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        @click="onSearchBtnClicked"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>

</template>

<script>
import {
  BButton, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import InputFilter from '../../../../filters/components/InputFilter.vue'

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const options = [
      { text: 'ทั้งหมด', value: null },
      { text: 'ใช้งาน', value: true },
      { text: 'ไม่ใช้งาน', value: false },
    ]

    const optionServices = [
      { text: 'ทั้งหมด', value: null },
      { text: 'เชื่อมต่อ', value: true },
      { text: 'ไม่เชื่อมต่อ', value: false },
    ]

    const searchList = [
      
      {
        id: 'name', 
        label: 'ชื่อหน่วยงาน', 
        value: '', 
        class: '', 
        style: '', 
        placeholder: 'ชื่อหน่วยงาน', 
        type: 'text', 
        options: [],
      },
      {
        id: 'isActive', 
        label: 'สถานะการใช้งาน', 
        value: null, 
        class: '', 
        style: '', 
        placeholder: 'สถานะการใช้งาน', 
        type: 'bselect', 
        options: options,
      },
      {
        id: 'isActive', 
        label: 'สถานะ Service', 
        value: null, 
        class: '', 
        style: '', 
        placeholder: 'สถานะ Service', 
        type: 'bselect', 
        options: optionServices,
      },
    ]


    return {
      options,
      search: searchList,
      props,
    }
  },
  mounted() {
    this.onSearchBtnClicked()
  },
  methods: {
    onResetBtnClicked(){
       this.search[0].value=null
       this.search[1].value=null
       this.search[2].value=null
    },
    onSearchBtnClicked() {

      const params = {
          name : this.search[0].value,
          isActive : this.search[1].value,
          isDataLink : this.search[2].value,
      }
    
      console.log('onSearchBtnClicked', params)
      
      this.$emit('handleSubmit', params)
    }
  }
}
</script>
 <style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
